import { createContext } from "react";

export type NotificationType = "INFO" | "SUCCESS" | "WARNING" | "ERROR";

export type Notification = {
  id: string;
  message: string;
  type: NotificationType;
  createdAt: string;
  read: boolean;
  actionLabel?: string;
  actionUrl?: string;
};

export type NotificationsContextProps = {
  notifications: Notification[];
  unreadCount: number;
  isDrawerOpen: boolean;

  openDrawer: () => void;
  closeDrawer: () => void;

  setNotifications: (data: Notification[]) => void;
  markAsRead: (id: string) => void;
};

export const notificationsContextInitialValues: NotificationsContextProps = {
  notifications: [],
  unreadCount: 0,
  isDrawerOpen: false,

  openDrawer: () => null,
  closeDrawer: () => null,

  setNotifications: () => null,
  markAsRead: () => null,
};

export const NotificationsContext = createContext<NotificationsContextProps>(
  notificationsContextInitialValues,
);
